import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { TimeBombService } from 'src/domain/time-bomb/time-bomb-service';
import { LoggingDatabaseProvider } from '@shared/logging';
import { DeviceIdProvider } from '../database/workspace-database/services';
import { AuthProvider } from '@domain/authentication';
import { SyncService } from '@domain/sync';
import { Storage } from '@ionic/storage-angular';
import { TokenProviderService } from 'src/api/authentication/services/token-provider.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
	public constructor(
		private translate: TranslateService,
		private statusBar: StatusBar,
		private timeBombService: TimeBombService,
		private splashScreen: SplashScreen,
		private loggingDatabaseProvider: LoggingDatabaseProvider,
		private deviceIdProvider: DeviceIdProvider,
		private authProvider: AuthProvider,
		private syncService: SyncService,
		private tokenProvider: TokenProviderService,
		private storage: Storage
	) {}

	public async ngOnInit() {
		await this.authProvider.setFusionUserId(null);
	}

	public async ngAfterViewInit() {
		await this.storage.create();
		this.initApp();
		this.splashScreen.hide();
	}

	public async initApp() {
		this.statusBar.styleDefault();
		this.translate.setDefaultLang('en');
		// this.timeBombService.init();
		// this.timeBombService.checkTimeBomb();
		// setTimeout(async () => {
		// 	this.timeBombService.checkTimeBomb();
		// });
		await this.loggingDatabaseProvider.create();
		await this.deviceIdProvider.setDeviceId();
		this.syncService.startSynching();
		this.tokenProvider.clearTokens().then(() => {
			//console.log('Tokens have been cleared at startup.');
		  });
	}
}
